import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import Heading from '@atlaskit/heading';
import Image from '@atlaskit/image';
import { Flex, Text } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import TeamPickerNoResultsView from './assets/TeamPickerNoResultsView.svg';
import messages from './messages';

const styles = cssMap({
	container: {
		paddingTop: token('space.100'),
		paddingBottom: token('space.100'),
		paddingLeft: token('space.300'),
		paddingRight: token('space.300'),
	},
	heading: {
		textAlign: 'center',
	},
});

export const NoResultsView = () => {
	const { formatMessage } = useIntl();

	return (
		<Flex
			direction="column"
			rowGap="space.200"
			alignItems="center"
			justifyContent="center"
			xcss={styles.container}
		>
			<Image src={TeamPickerNoResultsView} alt={formatMessage(messages.noResultsViewAltText)} />
			<Heading size="small">{formatMessage(messages.noResultsViewHeading)}</Heading>
			<Text>{formatMessage(messages.noResultsViewActionText)}</Text>
		</Flex>
	);
};
